import { DatadogErrorBoundary as a } from "../components/DatadogErrorBoundary.js";
import { cn as c } from "../lib/shadcn/utils/utils.js";
import m from "../assets/svg/Spinner/Spinner.js";
import { Suspense as l, lazy as n } from "react";
import { jsx as o } from "react/jsx-runtime";
var s = {
  arrowLeft: () => import("../assets/svg/ArrowLeft/index.js"),
  arrowRight: () => import("../assets/svg/ArrowRight/index.js"),
  addCircle: () => import("../assets/svg/AddCircle/index.js"),
  calendar: () => import("../assets/svg/Calendar/index.js"),
  delete: () => import("../assets/svg/Delete/index.js"),
  trash: () => import("../assets/svg/Trash/index.js"),
  "door-delivery": () => import("../assets/svg/DoorDelivery/index.js"),
  "clock-icon": () => import("../assets/svg/ClockIcon/index.js"),
  "checkmark-half-circle": () => import("../assets/svg/CheckmarkHalfCircle/index.js"),
  doctor: () => import("../assets/svg/Doctor/index.js"),
  "pill-pharmacy-repeat-arrow": () => import("../assets/svg/PillPharmacyRepeatArrow/index.js"),
  "prescription-rezept": () => import("../assets/svg/PrescriptionRezept/index.js"),
  shipment: () => import("../assets/svg/Shipment/index.js"),
  "drugs-pill": () => import("../assets/svg/DrugsPillClockCircle/index.js"),
  "package-box-refresh": () => import("../assets/svg/PackageBoxRefresh/index.js"),
  "zurrose-app-logo": () => import("../assets/svg/ZurroseAppLogo/index.js"),
  user: () => import("../assets/svg/User/index.js")
}, t = {}, g = (r, p) => {
  const i = s[r];
  if (!i) return null;
  t[r] || (t[r] = n(i));
  const e = t[r];
  return /* @__PURE__ */ o(a, {
    context: {
      boundary: "icon",
      icon: r
    },
    children: /* @__PURE__ */ o(l, {
      fallback: /* @__PURE__ */ o(m, { className: c("size-6") }),
      children: /* @__PURE__ */ o(e, {
        "data-testid": `icon-${r}`,
        className: p
      })
    })
  });
};
export {
  g as getIconByName
};

//# sourceMappingURL=icon.helper.js.map